// extracted by mini-css-extract-plugin
export var actions = "_kd-d";
export var benefitCard = "_kd-a";
export var benefitIcon = "_kd-b";
export var benefitLabel = "_kd-c";
export var benefits = "_kd-9";
export var bodyText = "_kd-8";
export var closeButton = "_kd-2";
export var content = "_kd-3";
export var eyebrow = "_kd-4";
export var heading = "_kd-5";
export var image = "_kd-f";
export var imagePanel = "_kd-e";
export var modal = "_kd-0";
export var shell = "_kd-1";
export var title = "_kd-6";
export var titleOffer = "_kd-7";